import { loadStripe } from '@stripe/stripe-js/pure';

let stripeClient: ReturnType<typeof loadStripe> | undefined;

/** Share the SDK across forms, but allow a failed download to be retried. */
export async function loadHotelCardStripe() {
  const pending = (stripeClient ??= loadStripe(
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  ));
  try {
    const client = await pending;
    if (!client && stripeClient === pending) stripeClient = undefined;
    return client;
  } catch (error) {
    if (stripeClient === pending) stripeClient = undefined;
    throw error;
  }
}

/** Download the SDK before Add a card, without creating a setup session. */
export function preloadHotelCardStripe() {
  if (
    /^pk_(test|live)_/.test(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '')
  )
    void loadHotelCardStripe().catch(() => {});
}
